module.exports = "<p>\n  famous works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/famous/famous.component.html
// module id = ../../../../../src/app/famous/famous.component.html
// module chunks = main